import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const FloatingHearts = () => {
  return (
    <>
      {[...Array(6)].map((_, i) => (
        <motion.div
          key={i}
          initial={{ y: 1000, x: Math.random() * window.innerWidth }}
          animate={{ y: -200 }}
          transition={{
            duration: 15 + Math.random() * 10,
            repeat: Infinity,
            delay: Math.random() * 5,
            ease: "linear",
          }}
          className="absolute text-pink-500 opacity-60"
          style={{ left: `${Math.random() * 100}%` }}
        >
          <Heart className="w-8 h-8 fill-pink-400" />
        </motion.div>
      ))}
    </>
  );
};

export default FloatingHearts;